const FREE_TRIAL_DAYS = 7;
export function getFreeTrialDaysLeft(createdAt) {
  if (!createdAt) return 0;
  const created = new Date(createdAt);
  const now = new Date();
  const msLeft =
    FREE_TRIAL_DAYS * 24 * 60 * 60 * 1000 - (now.getTime() - created.getTime());
  return Math.max(0, Math.ceil(msLeft / (1000 * 60 * 60 * 24)));
}
